import React, { Component } from 'react';
import gql from 'graphql-tag';
import { Mutation } from 'react-apollo';
import { ApolloConsumer } from 'react-apollo';
import Button from '../../artzu-ui/src/Button';
import { withRouter } from 'react-router-dom';
import '../../components/User/login.css';

class SaveRideshareParams extends Component {
  UPSERT_RIDESHARE = gql`
    mutation UpsertRidesharePlatform(
      $rideshareParams: RidesharePlatformAttributes!
    ) {
      upsertRidesharePlatform(newPlatform: $rideshareParams) {
        ridesharePlatform {
          name
          status
          email
          password
        }
        errors
      }
    }
  `;

  render() {
    const {
      rideshareParams,
      handleSubmit,
      handleModal,
      refetch
    } = this.props;
    return (
      <ApolloConsumer>
        {client => (
          <Mutation
            mutation={this.UPSERT_RIDESHARE}
            variables={{ rideshareParams }}
            onError={data => {
              console.log('error', data);
            }}
            onCompleted={data => {
              handleModal(false);
              refetch();
            }}>
            {upsertRidesharePlatform => (
              <div className="login__reconnect">
                <Button
                  size="xl"
                  secondary
                  label="Cancel"
                  onClick={() => {
                    handleModal(false);
                  }}
                />
                <Button
                  size="xl"
                  primary
                  type="submit"
                  label="Reconnect"
                  onClick={() => {
                    handleSubmit();
                    if (rideshareParams) {
                      upsertRidesharePlatform();
                    }
                  }}
                />
              </div>
            )}
          </Mutation>
        )}
      </ApolloConsumer>
    );
  }
}

export default withRouter(SaveRideshareParams);



// WEBPACK FOOTER //
// ./src/GraphQL/Mutations/SaveRideshareParams.js